import { render } from "./Panels_3.vue?vue&type=template&id=06b33edc&scoped=true"
import script from "./Panels_3.vue?vue&type=script&lang=js"
export * from "./Panels_3.vue?vue&type=script&lang=js"

import "./Panels_3.vue?vue&type=style&index=0&id=06b33edc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src546786139/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b33edc"]])

export default __exports__